var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ centered: true, 'align-start': _vm.top }},[_c('v-container',[(!_vm.top)?_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"mb-5",attrs:{"alt":"logo","src":require('@/assets/img/logo.png'),"width":"185"}})]):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }